// extracted by mini-css-extract-plugin
module.exports = {"ariaHidden":"AriaTextToSpeech_ariaHidden__1xvxQ"};